export default __webpack_public_path__ + "static/media/blue-upload-icon.a201b766.svg";